const BUTTON_LABELS = {
  hero: "Hero — App Store",
  demo_section: "Demo section — App Store",
  "get_started:final_cta": "Final CTA — Get started",
  "app_store:final_cta": "Final CTA — App Store",
  footer: "Footer — App Store",
  faq: "FAQ — App Store",
  hero_primary: "Hero — Get started",
  nav_getstarted: "Top menu — Get started",
  nav_getstarted_mobile: "Mobile menu — Get started",
  pricing_card_cta_starter: "Pricing — Starter",
  pricing_card_cta_professional: "Pricing — Professional",
  pricing_card_cta_business: "Pricing — Business",
};

const label = (type, b) => BUTTON_LABELS[`${type}:${b}`] || BUTTON_LABELS[b] || b;

export function SourcesTable({ rows }) {
  return (
    <div className="bg-white rounded-2xl border border-[#E6E1D8] overflow-hidden" data-testid="launch-stats-sources-table">
      <h2 className="font-semibold text-[16px] text-[#1A2A3A] px-5 sm:px-6 pt-5 pb-3">By ad source &amp; campaign</h2>
      <div className="overflow-x-auto">
        <table className="w-full text-[14px] min-w-[640px]">
          <thead className="text-[12px] uppercase tracking-wide text-[#5B6B7B] bg-[#FAF7F2]">
            <tr>
              {["Source", "Campaign", "Visits", "Get started", "Rate", "App Store", "Rate"].map((h, i) => (
                <th key={i} className={`px-5 py-2.5 font-semibold whitespace-nowrap ${i > 1 ? "text-right" : "text-left"}`}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr><td colSpan={7} className="px-5 py-8 text-center text-[#5B6B7B]">No visits in this period yet.</td></tr>
            )}
            {rows.map((r) => (
              <tr key={`${r.source}|${r.campaign}`} className="border-t border-[#EEE9E0]" data-testid={`source-row-${r.source}-${r.campaign}`}>
                <td className="px-5 py-3 font-medium text-[#1A2A3A] whitespace-nowrap">{r.source}</td>
                <td className="px-5 py-3 text-[#3D4F61] whitespace-nowrap">{r.campaign}</td>
                <td className="px-5 py-3 text-right tabular-nums">{r.visit}</td>
                <td className="px-5 py-3 text-right tabular-nums">{r.get_started}</td>
                <td className="px-5 py-3 text-right tabular-nums text-[#5B6B7B]">{r.get_started_rate}%</td>
                <td className="px-5 py-3 text-right tabular-nums">{r.app_store}</td>
                <td className="px-5 py-3 text-right tabular-nums text-[#5B6B7B]">{r.app_store_rate}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function ButtonsTable({ rows }) {
  return (
    <div className="bg-white rounded-2xl border border-[#E6E1D8] overflow-hidden" data-testid="launch-stats-buttons-table">
      <h2 className="font-semibold text-[16px] text-[#1A2A3A] px-5 sm:px-6 pt-5 pb-3">By button</h2>
      <table className="w-full text-[14px]">
        <tbody>
          {rows.length === 0 && (
            <tr><td className="px-5 py-8 text-center text-[#5B6B7B]">No clicks in this period yet.</td></tr>
          )}
          {rows.map((r) => (
            <tr key={`${r.type}|${r.button}`} className="border-t border-[#EEE9E0]" data-testid={`button-row-${r.type}-${r.button}`}>
              <td className="px-5 py-3">
                <span className={`inline-block w-2 h-2 rounded-full mr-2.5 ${r.type === "app_store" ? "bg-[#E8712C]" : "bg-[#334E68]"}`} />
                {label(r.type, r.button)}
              </td>
              <td className="px-5 py-3 text-right tabular-nums font-semibold">{r.clicks}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
